import { Link } from "@ui/Atoms/Link/Link";
export type RecentItem = {
	id: string;
	name: string;
	href: string;
	ago?: string;
	cover?: string | null;
};

type Props = {
	items: RecentItem[];
	/** Eyebrow label, e.g. "RECENT BEKEKEN". */
	label: string;
};

export function RecentRow({ items, label }: Props) {
	if (items.length === 0) return null;

	return (
		<div className="flex flex-col gap-2.5">
			<div className="text-[11px] font-bold uppercase tracking-[0.06em] text-[var(--content-muted)]">
				{label}
			</div>
			<div className="flex gap-2 overflow-x-auto scrollbar-hide -mx-5 px-5 pb-0.5">
				{items.map((item) => (
					<Link
						key={item.id}
						href={item.href}
						className="flex shrink-0 items-center gap-2.5 rounded-[var(--radius-md)] bg-[var(--surface-elevated)] py-2 pl-2.5 pr-4"
					>
						<span
							className="h-[34px] w-[34px] shrink-0 overflow-hidden rounded-[var(--radius-sm)] bg-[var(--border-strong)]"
							aria-hidden="true"
						>
							{item.cover && (
								<img
									src={item.cover}
									alt=""
									className="h-full w-full object-cover"
								/>
							)}
						</span>
						<span className="flex flex-col">
							<span className="whitespace-nowrap text-[13.5px] font-bold text-[var(--content-primary)]">
								{item.name}
							</span>
							{item.ago && (
								<span className="whitespace-nowrap text-[11.5px] font-semibold text-[var(--content-faint)]">
									{item.ago}
								</span>
							)}
						</span>
					</Link>
				))}
			</div>
		</div>
	);
}
